import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import SlugRouter from "@/pages/SlugRouter";
import NotFound from "@/pages/NotFound";
import SmoothScroll from "@/components/SmoothScroll";
import AnalyticsRouter from "@/components/AnalyticsRouter";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <HelmetProvider>
      <SmoothScroll>
        <div className="App">
          <BrowserRouter>
            <AnalyticsRouter />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:slug" element={<SlugRouter />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <CookieBanner />
          <Toaster position="top-center" richColors closeButton />
        </div>
      </SmoothScroll>
    </HelmetProvider>
  );
}

export default App;
